export class ChatTicketHeaderEntity {
    id?: string | null;
    number?: number | null;
    createdAt?: string | null;
    dateClosed?: string | null;

    constructor(data?: Partial<ChatTicketHeaderEntity>) {
        Object.assign(this, data);
    }

    public static fromJson(json: Record<string, any>): ChatTicketHeaderEntity {
        return new ChatTicketHeaderEntity({
            id: json['id'] ?? null,
            number: json['number'] ?? null,
            createdAt: json['createdAt'] ?? null,
            dateClosed: json['dateClosed'] ?? null
        });
    }
}
